module.exports = __webpack_public_path__ + "c71d77ea5b259927dd175be674af7542.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-top-s.png
// module id = 2908
// module chunks = 0